import { render, staticRenderFns } from "./NbDownload.vue?vue&type=template&id=478865c3"
import script from "./NbDownload.vue?vue&type=script&lang=js"
export * from "./NbDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports